// Expandable clip card: gradient + toggle only when content actually overflows.
(function () {
  function setup(card) {
    if (card.hasAttribute('data-sk-features-init')) return;
    card.setAttribute('data-sk-features-init', '1');
    var toggle = card.nextElementSibling;
    var hasToggle = toggle && toggle.hasAttribute('data-sk-features-toggle');
    var moreLabel = hasToggle ? toggle.querySelector('[data-sk-more]') : null;
    var lessLabel = hasToggle ? toggle.querySelector('[data-sk-less]') : null;

    function refresh() {
      if (card.classList.contains('is-expanded')) {
        card.classList.remove('has-overflow');
        return;
      }
      var overflows = card.scrollHeight > card.clientHeight + 2;
      card.classList.toggle('has-overflow', overflows);
      if (hasToggle) toggle.hidden = !overflows;
    }

    if (hasToggle) {
      toggle.addEventListener('click', function () {
        var expanded = card.classList.toggle('is-expanded');
        if (moreLabel) moreLabel.hidden = expanded;
        if (lessLabel) lessLabel.hidden = !expanded;
        refresh();
      });
    }

    refresh();
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-sk-features-clip]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
